import * as ko from 'knockout';
import { toastService } from '../../../toastService';
import * as ROUTES from '../../routes';
import { UIAction } from '../../uiAction';
import * as i18next from './../../../i18n/i18n';

export const WIDGET_NAME = 'ui-superuser-useroverview';

export type IParamsInner = undefined;

export type IParams = ROUTES.IRoutableParams<IParamsInner>;

export class UserOverviewRoute implements ROUTES.IRoute<IParamsInner> {
    public readonly widgetName = WIDGET_NAME;
    public readonly title = ko.pureComputed(() => {
        return i18next.t(['ui.superuser.useroverview.USER']);
    });

    private readonly showHelp = new UIAction(undefined, async () => {
        const msg = i18next.t(['ui.superuser.useroverview.LIST_OF_ALL_ACTIVE_USERS_CLICK_ON_THE_NAME_OF_THE_USER_TO_VIEW_THE_DETAILED_DATA']);

        toastService.info(msg);
    });

    constructor(readonly widgetParams: IParamsInner) {
    }
}

export const FACTORY = ROUTES.registerRoute<{}>({
    route: '/superuser/user',
    toParams: map => ({
    }),
    fromParams: (p, map) => {
    },
    create: async p => {
        return new UserOverviewRoute(undefined);
    },
});
